import React from 'react';
import { CharacterStats, StatType } from '../../../../../shared/CharacterTypes';
import { getStatAbbreviation, getStatDescription } from './StatHelpers';
import { StatLedgerRow } from './StatLedgerRow';

interface UtilityStatsPanelProps {
  stats: CharacterStats;
  characterClass?: string;
}

const UTILITY_STATS = [
  { stat: StatType.ACCURACY, label: 'Accuracy' },
  { stat: StatType.AVOIDABILITY, label: 'Avoidability' },
  { stat: StatType.SPEED, label: 'Speed' },
  { stat: StatType.JUMP, label: 'Jump' },
] as const;

export const UtilityStatsPanel: React.FC<UtilityStatsPanelProps> = ({ stats, characterClass }) => (
  <section className="character-stat-section" aria-labelledby="character-utility-stats-heading">
    <h3 id="character-utility-stats-heading">Utility</h3>
    <p className="character-stat-section__intro">Current synced hit, dodge, and movement ratings.</p>
    <div className="character-stat-list" role="list">
      {UTILITY_STATS.map(({ stat, label }) => (
        <StatLedgerRow
          key={stat}
          statType={stat}
          stats={stats}
          characterClass={characterClass}
          abbreviation={getStatAbbreviation(stat)}
          label={label}
          value={stats[stat]}
          description={getStatDescription(stat)}
        />
      ))}
    </div>
  </section>
);
